var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, useContext, useMemo, } from 'react';
import { optionBorderWidth, optionPadding, selectedOptionBorderWidth, selectedOptionPadding, } from '../../styles/border';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
import { usePickerOptionInputStateContext } from '../Picker';
import { PickerContext } from '../Picker/PickerContext';
import { attributeIcons } from './attributeIcons';
const strikethroughBorderWidth = 3;
const customOptionPadding = styleUtils.remToPxValue(optionPadding) + styleUtils.remToPxValue(theme.spacing.x2);
const customSelectedOptionPadding = selectedOptionPadding + styleUtils.remToPxValue(theme.spacing.x2);
const AttributeIcon = (_a) => {
    var { iconType } = _a, props = __rest(_a, ["iconType"]);
    const { isLoading, } = useContext(PickerContext);
    const { isDisabled, isFocused, isHovering, isSelected, } = usePickerOptionInputStateContext();
    const optionStyles = useMemo(() => (css `
        ${styleUtils.borderBox}
        align-items: center;
        border-color: ${theme.colors.gray400};
        border-style: solid;
        border-width: ${styleUtils.rem(optionBorderWidth)};
        display: inline-block;
        line-height: 0;
        position: relative;
        width: 100%;

        ${isSelected && css `
          border-color: ${theme.colors.gray700};
          border-width: ${styleUtils.rem(selectedOptionBorderWidth)};
        `}

        ${(isFocused || isHovering) && css `
          border-color: ${theme.colors.gray700};
          border-width: ${styleUtils.rem(optionBorderWidth)};
          cursor: pointer;
        `}

        ${isSelected && (isFocused || isHovering) && css `
          border-color: ${theme.colors.gray700};
          border-width: ${styleUtils.rem(selectedOptionBorderWidth)};
        `}

        ${(isLoading || isDisabled) && css `
          border-color: ${theme.colors.gray400};
          color: ${theme.colors.gray500};
          cursor: default;
        `}

        ${(isLoading || isDisabled) && isHovering && css `
          border-color: ${theme.colors.gray400};
          cursor: default;
        `}
      `), [
        isLoading,
        isDisabled,
        isSelected,
        isFocused,
        isHovering,
    ]);
    const strikethroughContainerStyles = useMemo(() => (css `
        clip-path: inset(0);
        height: 100%;
        left: 0;
        position: absolute;
        top: 0;
        width: 100%;
      `), []);
    const strikethroughStyles = useMemo(() => (css `
        border-left-color: ${theme.colors.gray400};
        border-left-style: solid;
        border-left-width: ${styleUtils.rem(strikethroughBorderWidth)};
        height: 100%;
        margin: auto;
        transform: skew(45deg);
        width: 0;
      `), []);
    const iconStyles = useMemo(() => (css `
      padding-bottom: ${styleUtils.rem(customOptionPadding)};
      padding-left: ${styleUtils.rem(customOptionPadding)};
      padding-right: ${styleUtils.rem(customOptionPadding)};
      padding-top: ${styleUtils.rem(customOptionPadding)};


      ${isSelected && css `
        padding-bottom: ${styleUtils.rem(customSelectedOptionPadding)};
        padding-left: ${styleUtils.rem(customSelectedOptionPadding)};
        padding-right: ${styleUtils.rem(customSelectedOptionPadding)};
        padding-top: ${styleUtils.rem(customSelectedOptionPadding)};
      `}

      ${(isHovering || isFocused) && css `
        padding-bottom: ${styleUtils.rem(customOptionPadding)};
        padding-left: ${styleUtils.rem(customOptionPadding)};
        padding-right: ${styleUtils.rem(customOptionPadding)};
        padding-top: ${styleUtils.rem(customOptionPadding)};
      `}

      ${isSelected && (isHovering || isFocused) && css `
        padding-bottom: ${styleUtils.rem(customSelectedOptionPadding)};
        padding-left: ${styleUtils.rem(customSelectedOptionPadding)};
        padding-right: ${styleUtils.rem(customSelectedOptionPadding)};
        padding-top: ${styleUtils.rem(customSelectedOptionPadding)};
      `}
      `), [
        isSelected,
        isHovering,
        isFocused,
    ]);
    return (_jsxs("div", Object.assign({ css: optionStyles }, { children: [isDisabled
                && !isLoading
                && (_jsx("div", Object.assign({ css: strikethroughContainerStyles }, { children: _jsx("div", { css: strikethroughStyles }) }))), _jsx("div", Object.assign({ css: iconStyles }, { children: _jsx("svg", Object.assign({ fill: "none", height: "40", viewBox: "0 0 40 40", width: "40" }, { children: iconType === 'external'
                        ? (_jsx("path", { d: 'path' in props ? props.path : '', fill: "currentColor", fillRule: "evenodd" }))
                        : attributeIcons[iconType] })) }))] })));
};
const MemoizedAttributeIcon = memo(AttributeIcon);
export { MemoizedAttributeIcon as AttributeIcon };
// MC-1068 Temporary hack for Storybook.
export default AttributeIcon;
